import React, {  } from 'react';

import { dateTimeFormatOptions } from '../types';
import { DatTimeFormatRuleSet } from './Intl.DateTimeFormat';
import { IntlFunction } from './Intl.Function';

export const IntlDateTimeFormatResolvedOptions = () => (
	<IntlFunction
		input={[]}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions"
		header="Intl.DateTimeFormat.prototype.resolvedOptions"
		description="Returns a new object with properties reflecting the locale and date and time formatting options computed during initialization of this [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) object."
		options={dateTimeFormatOptions}
		ruleSet={DatTimeFormatRuleSet}
		template="new Intl.DateTimeFormat(##locale##, ##options##).resolvedOptions()" />
)